import {
  RowDataReducerActionPayload,
  RowDataReducerState,
  RowDataObject,
  RowData,
} from "../../../types";

export const updateObjectRowAction = (
  payload: Partial<RowDataReducerActionPayload>,
  state: RowDataReducerState,
): RowDataReducerState => {
  const { propertyKey, selectedTabSectionKey, newFieldValue, rowIndex } =
    payload;
  if (!propertyKey || newFieldValue === undefined || rowIndex === undefined)
    return state;

  if (selectedTabSectionKey) {
    return updateNestedObjectRow(
      propertyKey,
      newFieldValue as RowDataObject,
      rowIndex,
      selectedTabSectionKey,
      state,
    );
  }

  return updateObjectRow(
    propertyKey,
    newFieldValue as RowDataObject,
    rowIndex,
    state,
  );
};

const updateNestedObjectRow = (
  propertyKey: string,
  newFieldValue: RowDataObject,
  rowIndex: number,
  selectedTabSectionKey: string,
  state: RowDataReducerState,
): RowDataReducerState => {
  const existingArray =
    ((state.rowData[selectedTabSectionKey] as RowData)?.[
      propertyKey
    ] as RowDataObject[]) ?? [];

  const updatedArray = existingArray.map((row, index) =>
    index === rowIndex ? { ...newFieldValue } : row,
  );

  return {
    ...state,
    rowData: {
      ...state.rowData,
      [selectedTabSectionKey]: {
        ...(state.rowData[selectedTabSectionKey] as RowData),
        [propertyKey]: updatedArray,
      },
    },
  };
};

const updateObjectRow = (
  propertyKey: string,
  newFieldValue: RowDataObject,
  rowIndex: number,
  state: RowDataReducerState,
): RowDataReducerState => {
  const existingArray = (state.rowData[propertyKey] as RowDataObject[]) ?? [];

  const updatedArray = existingArray.map((row, index) =>
    index === rowIndex ? { ...newFieldValue } : row,
  );

  return {
    ...state,
    rowData: {
      ...state.rowData,
      [propertyKey]: updatedArray,
    },
  };
};
